<template>
  <div
    class="bg-background-neutral-secondary flex flex-col items-center space-y-4 rounded-2xl p-4 text-center"
  >
    <slot name="image"></slot>
    <div class="flex flex-col">
      <h4 class="text-text-neutral-primary text-base font-semibold">
        {{ title }}
      </h4>
      <p class="text-text-neutral-quaternary text-sm">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    title: string;
    message: string;
  }>();
</script>
